import React, {useEffect, useState} from 'react'
import SimpleTable from './components/SimpleTable'
import { onGetParamsFromState } from './custom_functions'
import AddSegmentModal from './modals/AddSegmentModal'
import DeleteModal from './modals/DeleteModal'
import { request_segments } from './requests'

const SegmentsView = (props) => {

    const {history} = props

    //general
    const [loading, setLoading] = useState(false)
    const [segments, setSegments] = useState([])

    //modals
    const [add_modal, setAddModal] = useState(false)
    const [selected, setSelected] = useState(null)
    const [delete_modal, setDeleteModal] = useState(false)
 
    //table
    const [total, setTotal] = useState(10)
    const [tableFilter, setTableFilter] = useState({limit:10, offset:0, order:1, order_by:'id_segment'})
    const [search, setSearch] = useState(null)

    useEffect(() => {
        const initModule = async() => {try {
            window.scrollTo({top: 0, behavior: 'smooth'})
            setLoading(true)
            const params = onGetParamsFromState(tableFilter, search)
            console.log(params)
            const _segments = await request_segments(params)
            setSegments(_segments.segments_data)
            setTotal(_segments.count)
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }}
        initModule()
    }, [search, tableFilter])

    
    const onChangeSearch = (val) => {
        setSearch(val)
        setTableFilter({...tableFilter, offset:0})
    }

    const onUpdateCompleted = async() => {
        const params = onGetParamsFromState(tableFilter, search)
        const _segments = await request_segments(params)
        setSegments(_segments.segments_data)
        setTotal(_segments.count)
        setAddModal(false)
    }


    const onSelectedItem = (item, type) => {
        const {id_segment} = item
        setSelected(id_segment)
        console.log(id_segment)
        if(type === 'edit') history.push(`/catalogs/segment/${id_segment}`)
        if(type === 'delete') setDeleteModal(true)
    }

    return(
        <div>
            <AddSegmentModal open={add_modal} onClose={() => setAddModal(false)} onUpdateCompleted={onUpdateCompleted} />
            <DeleteModal open={delete_modal} onClose={() => setDeleteModal(false)} onUpdateCompleted={onUpdateCompleted} 
            id={selected}/>
            <SimpleTable
                data={segments} 
                tableFilter={tableFilter}
                search={search}
                total={total}
                loading={loading}
                onAddRegister={() => setAddModal(true)}
                onChangeSearch={onChangeSearch}
                onUpdateTableFilter={(data) => setTableFilter(data)}
                onSelectedItem={onSelectedItem}
            />
        </div>
    )
}

export default SegmentsView